<!-- HTML Template -->
<div class="login-container  min-vh-100  d-flex align-items-start justify-content-center pt-4">
  <div class="row w-100 justify-content-center">
    <div class="col-12 col-sm-8 col-md-6 col-lg-4 col-xl-4">
      <div class="card  mt-3  shadow-lg border-0 login-card ">  
        
        <!-- Header Section with Checkmark -->
         <div class="card-header text-white text-center py-5   head-section">
          <div class="logo-container d-flex align-items-center justify-content-center">
         

  <h3 class="mt-0 d-flex align-items-center justify-content-center" style="gap: 0.5rem;">
  <img src="assets/images/checks.png" alt="Check Icon" width="45" height="44">
   <span style="letter-spacing: 1px;">EfficX Builder</span>
</h3>



          </div>
        </div>
          
        <div class="card-body bg-white rounded-4 mx-5  mb-3 px-0 py-3 mt-0 z-1 position-relative ">
      <div class="text-center mb-3">
        <div class="efficx-logo-container mb-2" >
            <img src="assets/images/efficx_logo_small.png" alt="efficx-logo" class="efficx-logo ">
              
            </div>
        <h3 class="mb-0 login-title" style="font-family: 'Inter', sans-serif; font-size: 30px;"> {{ showForgotPasswordForm ? 'Forgot Password' : 'Account Login' }}</h3>
        <small class="subtitle">Empowering Leadership Efficiency</small>
        </div>


          <!-- Form Section --> 
           <div *ngIf="!showForgotPasswordForm" class="form-section px-4 pb-0">
            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()"> 

              <div *ngIf="errorMessage" class="alert alert-danger mb-3" role="alert">
                {{ errorMessage }}
              </div>
              
              <!-- Username field -->
              <div class="mb-3">
                <label for="username" class="form-label">Username</label>
                <input 
                  type="text" 
                  id="username" 
                  class="form-control"
                  formControlName="Email" 
                  autocomplete="username"
                  #emailInput 
                 (keydown.enter)="focusPassword(); $event.preventDefault()">

                  <div *ngIf="loginForm.get('Email')?.touched && loginForm.get('Email')?.invalid" class="text-danger small">
                    <div *ngIf="loginForm.get('Email')?.errors?.['required']">
                      Email is required
                    </div>
                    
                   
                  </div>


              </div> 
              
              <!-- Password field -->
              <div class="mb-3 position-relative">
                <label for="password" class="form-label">Password</label>
                <input 
                  [type]="showPassword ? 'text' : 'password'"  
                  id="password" 
                  class="form-control"
                  formControlName="Password" 
                  autocomplete="current-password"
                  #passwordInput>

               
                  <div *ngIf="loginForm.get('Password')?.touched && loginForm.get('Password')?.invalid" class="text-danger small">
                    <div *ngIf="loginForm.get('Password')?.errors?.['required']">
                      Password is required
                    </div>
                    
                  </div>

                  <span 
                  class="position-absolute top-50 end-0 translate-middle-y me-2 password-toggle" 
                  style="cursor: pointer;" 
                  (click)="togglePassword()">
                 <i class="bi " [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                </span>

              </div>
              
              <!-- Forgot password link -->
             <div class="mb-4 text-end">
                <a href="#" class="forgot-link"(click)="toggleForgotPassword(); $event.preventDefault()">Forgot Password?</a>
              </div> 

              <!-- Error message -->
              
               
              <!-- Submit Button -->
               <div class="text-center">
                <button type="submit" class="btn  py-2 px-5 fw-medium login-btn" >
                  Login
                </button>
              </div>
              </form>
          </div>

         
          <!-- FORGOT PASSWORD FORM -->
          <div *ngIf="showForgotPasswordForm" class="form-section px-4 pb-0">
            <form (ngSubmit)="onForgotPassword()">
               <!-- Success message -->
                <div *ngIf="successMessage" class="alert alert-success alert-dismissible fade show mb-3" role="alert">
                  {{ successMessage }}
                 <button type="button" class="btn-close" aria-label="Close" (click)="successMessage = ''"></button>
                </div>

               <!-- Error message -->
               <div *ngIf="errorMessage" class="alert alert-danger mb-3" role="alert">
                {{ errorMessage }}
               </div>

              <div class="mb-3">
                <label for="forgotEmail" class="form-label">Enter your email</label>
                <input type="email" id="forgotEmail" class="form-control" [(ngModel)]="forgotPasswordEmail" name="forgotPasswordEmail" required>
              </div>
              
              <div class="text-center mb-2 mt-4" *ngIf="!successMessage">
                <button type="submit" class="btn py-2 px-4 fw-medium login-btn" [disabled]="isForgotSubmitting">
                  {{ isForgotSubmitting ? 'Sending...' : 'Send Reset Link' }}
                </button>
              </div>

               <!-- Back to Login button  -->
              <div class="text-center mb-2 mt-4" *ngIf="successMessage">
                 <button type="button" class="btn py-2 px-4 fw-medium login-btn" 
                   (click)="toggleForgotPassword(); successMessage=''">
                      Back to Login
                 </button>
                 
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>